/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Store } from 'redux'
import { ILocalizationState } from 'redux-app/types/localization'
import createStore from './create'

export interface IState {
  localization: ILocalizationState,
}

const store: Store<IState> = createStore()

export default store
